/* istanbul ignore file */

module.exports = {
  "account.account.backButton": "Terug",
  "account.account.continueButton": "Doorgaan",
  "account.account.loggedInAs": "Je bent ingelogd als :email",
  "account.account.logoutButton": "Uitloggen",
  "account.account.logoutText": "Ben je dit niet? Je kunt uitloggen en dan inloggen met een ander account of een nieuw account aanmaken.",
  "account.emailConfirmForm.backButton": "Terug",
  "account.emailConfirmForm.changeEmail": "E-mailadres wijzigen",
  "account.emailConfirmForm.checkYourEmail": "Check je email",
  "account.emailConfirmForm.codeLabel": "Voer je verificatiecode in",
  "account.emailConfirmForm.codeName": "Verificatiecode",
  "account.emailConfirmForm.codeWrong": "Code is onjuist of verlopen",
  "account.emailConfirmForm.continueButton": "Doorgaan",
  "account.emailConfirmForm.emailLabel": "E-mailadres",
  "account.emailConfirmForm.receivedNoCode": "Heb je de code niet ontvangen?",
  "account.emailConfirmForm.sendCodeAgain": "Email opnieuw verzenden",
  "account.emailConfirmForm.sendCodeSuccess": "We hebben je verificatiecode gestuurd naar het e-mailadres :email.",
  "account.emailConfirmForm.sentCode": "We hebben je een code gestuurd",
  "account.emailForm.backButton": "Terug",
  "account.emailForm.continueButton": "Doorgaan",
  "account.emailForm.emailLabel": "E-mailadres",
  "account.emailForm.emailName": "E-mail",
  "account.emailForm.emailPlaceholder": "email@example.com",
  "account.emailForm.intro": "Als je <strong>al een mySugr account hebt</strong>, voer dan hetzelfde e-mailadres in om ervoor te zorgen dat je bundel wordt toegewezen aan je bestaande account. Je kunt je e-mailadres vinden in je profiel in de mySugr App.",
  "account.emailForm.proVoucherIntro": "Als je <strong>al een mySugr account hebt</strong>, voer dan hetzelfde e-mailadres in om ervoor te zorgen dat je tegoedbon wordt toegewezen aan je bestaande account. Je kunt je e-mailadres vinden in je profiel in de mySugr App.",
  "account.loginForm.backButton": "Terug",
  "account.loginForm.continueButton": "Doorgaan",
  "account.loginForm.emailLabel": "Je e-mailadres",
  "account.loginForm.emailName": "E-mail",
  "account.loginForm.forgotPassword": "Wachtwoord vergeten?",
  "account.loginForm.passwordLabel": "Voer je wachtwoord in",
  "account.loginForm.passwordName": "Wachtwoord",
  "account.loginForm.passwordResetRequestedText": "Je hebt gevraagd om het wachtwoord opnieuw in te stellen. Controleer je e-mails en volg de instructies op die we je hebben toegestuurd.",
  "account.loginForm.redeemButton": "Inwisselen",
  "account.loginTitle": "Login",
  "account.loginTitleRedeem": "Log in om je tegoedbon in te wisselen",
  "account.registerForm.backButton": "Terug",
  "account.registerForm.consentsName": "Instemmingen",
  "account.registerForm.continueButton": "Doorgaan",
  "account.registerForm.countryLabel": "Selecteer het land waar je woont",
  "account.registerForm.emailLabel": "Je e-mailadres",
  "account.registerForm.emailName": "E-mail",
  "account.registerForm.passwordConfirmLabel": "Voer het wachtwoord opnieuw in",
  "account.registerForm.passwordConfirmName": "Wachtwoordbevestiging",
  "account.registerForm.passwordHint": "Moet minimaal 6 tekens bevatten.",
  "account.registerForm.passwordHintLength": "Moet minimaal :minLength tekens bevatten.",
  "account.registerForm.passwordLabel": "Wachtwoord",
  "account.registerForm.passwordName": "Wachtwoord",
  "account.registerForm.redeemButton": "Inwisselen",
  "account.registerForm.verifiedEmail": "Geverifieerd",
  "account.registerTitle": "Registratie",
  "account.registerTitleRedeem": "Maak een account aan om je tegoedbon in te wisselen",
  "account.resetPassword.checkYourEmail": "Je hebt erom gevraagd om een wachtwoord opnieuw in te stellen.",
  "account.resetPassword.passwordConfirmLabel": "Nieuw wachtwoord bevestigen",
  "account.resetPassword.passwordConfirmName": "Nieuw wachtwoord bevestigen",
  "account.resetPassword.passwordHint": "Moet minimaal 6 tekens bevatten.",
  "account.resetPassword.passwordHintLength": "Moet minimaal :minLength tekens bevatten.",
  "account.resetPassword.passwordLabel": "Nieuw wachtwoord invoeren",
  "account.resetPassword.passwordName": "Nieuw wachtwoord invoeren",
  "account.resetPassword.sentCode": "We hebben een code naar je e-mailadres verzonden",
  "account.resetPasswordCodeVerification.backButton": "Terug",
  "account.resetPasswordCodeVerification.continueButton": "Code controleren",
  "account.resetPasswordForm.backButton": "Terug",
  "account.resetPasswordForm.saveButton": "Wachtwoord opslaan",
  "account.resetPasswordFormText": "Kies een nieuw wachtwoord voor je mySugr-account.",
  "account.resetPasswordTitle": "Wachtwoord opnieuw instellen",
  "account.stepName": "Account",
  "account.title": "Registratie / Login",
  "AccuChekRegistration_description": "Begin mySugr te gebruiken met je Accu-Chek-account. <strong><a href=\"https://www.mysugr.com/en/mysugr-and-accu-chek/\" target=\"_blank\" rel=\"noopener\">Meer informatie</a></strong>",
  "AccuChekRegistration_or": "of",
  "activateProTitle": "mySugr PRO activeren",
  "appLegalNotice": "De mySugr App wordt aangeboden als onderdeel van de bundel. Het gebruik van de app is vereist om alle services in de bundel te ontvangen.",
  "appProvider.title": "App-provider",
  "birthdayLabel": "Geboortedatum",
  "bundle.item.alt_text.strips_subscription_guide.description": "op basis van je geïmporteerde metingen (zonder lancetten)",
  "bundle.item.alt_text.strips_subscription_guide.name.2": "",
  "bundle.item.coach.description": "Ondersteuning en contact met je behandelteam in de mySugr App.",
  "bundle.item.coach.name": "Gecertificeerde diabetestrainer",
  "bundle.item.cuff.description": "Aangekoppelde bloeddrukmeter.",
  "bundle.item.cuff.name": "1x bloeddrukmeter",
  "bundle.item.dkv_coach_1.name": "",
  "bundle.item.fastclix_lancets_2.description": "34 lancettenhouder met 6 voorgeladen lancetten.",
  "bundle.item.fastclix_lancets_2.name": "204x lancetten",
  "bundle.item.fastclix_lancets.description": "17 lancettenhouder met 6 voorgeladen lancetten.",
  "bundle.item.fastclix_lancets.name": "102x lancetten",
  "bundle.item.fastclix_lancing_kit.description": "Met een drum van 6 voorgeladen lancetten, dus geen zichtbare of aanraakbare lancetten.",
  "bundle.item.fastclix_lancing_kit.name": "1x Accu-Chek FastClix prikpen",
  "bundle.item.guide_3.description": "Stuurt je bloedsuikerwaarden rechtstreeks naar de mySugr App.",
  "bundle.item.guide_3.name": "1x Accu-Chek® Guide meter en prikpen",
  "bundle.item.guide_4.description": "Stuurt je bloedsuikerwaarden rechtstreeks naar de mySugr App.",
  "bundle.item.guide_4.name": "1x Accu-Chek® Guide meter en prikpen",
  "bundle.item.guide_me.description": "Stuurt je bloedsuikerwaarden rechtstreeks naar de mySugr App.",
  "bundle.item.guide_me.name": "1x Accu-Chek® Guide Me meter",
  "bundle.item.guide_strips_1.description.country_de": "Vier verpakkingen Accu-Chek® Guide teststrips.",
  "bundle.item.guide_strips.description": "Vijf verpakkingen Accu-Chek® Guide teststrips.",
  "bundle.item.guide_strips.name": ":amountx teststrips",
  "bundle.item.guide.description": "Stuurt je bloedsuikerwaarden rechtstreeks naar de mySugr App.",
  "bundle.item.guide.name": "1x Accu-Chek® Guide meter",
  "bundle.item.mysugr_coach_voucher_based_1.description": "Ondersteuning en contact met je behandelteam in de mySugr App.",
  "bundle.item.mysugr_coach_voucher_based_1.name": "Gecertificeerde diabetestrainer",
  "bundle.item.mysugr_strips_subscription_guide_2.description": "op basis van je geïmporteerde metingen.",
  "bundle.item.mysugr_strips_subscription_guide_2.name": "Automatische levering van teststrips",
  "bundle.item.mysugr_strips_subscription_guide_2.name.2": "Onbeperkte levering van teststrips",
  "bundle.item.pro.description": "Gesynchroniseerde BG's, geschatte HbA1c, PDF-rapporten, uitdagingen, etc.",
  "bundle.item.pro.name": "mySugr App met PRO-functies",
  "bundle.item.scale.description": "Aangekoppelde weegschaal.",
  "bundle.item.scale.name": "1x weegschaal",
  "bundle.item.schwenninger_coach_1.description": "",
  "bundle.item.schwenninger_coach_1.name": "",
  "bundle.item.servidigest_coach_1.description": "",
  "bundle.item.servidigest_coach_1.name": "Diabetes Coach",
  "bundle.item.softclix_lancets.name": ":amountx 100 lancetten",
  "bundle.item.softclix_lancing_kit.description": "Eenvoudig te gebruiken. Minder pijn.",
  "bundle.item.softclix_lancing_kit.name": "1x Accu-Chek® Softclix  prikpen",
  "bundle.item.strips_subscription_guide.description": "op basis van je geïmporteerde metingen.",
  "bundle.item.strips_subscription_guide.name": "Automatische levering van teststrips",
  "bundle.item.strips_subscription_guide.name.2": "Onbeperkte levering van teststrips",
  "bundleDelivery.text": "Je bundel komt aan over :time werkdagen. We sturen je een e-mail met de leveringsgegevens. <b>Alle toekomstige leveringen worden geactiveerd vanuit de app.</b>",
  "bundleGroupItemName.activisionblizzard_coach_1": "",
  "bundleGroupItemName.fastclix_lancets_1": "",
  "bundleGroupItemName.fastclix_lancets_2": "",
  "bundleGroupItemName.fastclix_lancing_kit_1": "",
  "bundleGroupItemName.guide_1": "",
  "bundleGroupItemName.guide_3": "",
  "bundleGroupItemName.guide_4": "",
  "bundleGroupItemName.guide_me_1": "",
  "bundleGroupItemName.guide_strips_1": "",
  "bundleGroupItemName.mysugr_coach_1": "",
  "bundleGroupItemName.mysugr_coach_2": "",
  "bundleGroupItemName.mysugr_coach_3": "",
  "bundleGroupItemName.mysugr_coach_5": "",
  "bundleGroupItemName.mysugr_coach_6": "",
  "bundleGroupItemName.mysugr_coach_6_copy": "",
  "bundleGroupItemName.mysugr_pro_1": "",
  "bundleGroupItemName.mysugr_pro_2": "",
  "bundleGroupItemName.mysugr_pro_3": "",
  "bundleGroupItemName.mysugr_pro_4": "",
  "bundleGroupItemName.mysugr_strips_subscription_guide_1": "",
  "bundleGroupItemName.mysugr_strips_subscription_guide_2": "",
  "bundleGroupItemName.mysugr_strips_subscription_guide_3": "",
  "bundleGroupItemName.schwenninger_coach_1": "",
  "bundleGroupItemName.servidigest_coach_1": "",
  "bundleGroupItemName.sigroup_coach_1": "",
  "bundleGroupItemName.us_spanish_coach_1": "",
  "bundleProduct.content.items.coach": "Coach",
  "bundleProduct.content.items.cuff": "Bloeddrukmeter",
  "bundleProduct.content.items.fastclix_lancets": "Lancetten",
  "bundleProduct.content.items.fastclix_lancing_kit": "Prikpen",
  "bundleProduct.content.items.guide": "Bloedglucosemeter",
  "bundleProduct.content.items.guide_me": "Bloedglucosemeter",
  "bundleProduct.content.items.mysugr_coach_voucher_based_1": "Coach",
  "bundleProduct.content.items.pro": "PRO App",
  "bundleProduct.content.items.scale": "Weeg-<wbr>schaal",
  "bundleProduct.content.items.servidigest_coach_1": "Coach",
  "bundleProduct.content.items.softclix_lancets": "Lancetten",
  "bundleProduct.content.items.softclix_lancing_kit": "Prikpen",
  "bundleProduct.content.items.strips_subscription_guide": "Teststrips",
  "bundleProduct.content.title": "Je bundel omvat:",
  "bundleProduct.content.title.roche-benefits-us": "",
  "bundleProduct.content.title.roche-benefits-us-coach": "",
  "bundleProduct.continueButton": "Doorgaan",
  "bundleProduct.countryRestriction.de": "Alleen Duitsland",
  "bundleProduct.countryRestriction.sg": "",
  "bundleProduct.countryRestriction.us": "Alleen VS",
  "bundleProduct.description.list.alt_text.strips_subscription_guide.2": "",
  "bundleProduct.description.list.aok_nordwest_coach_1": "",
  "bundleProduct.description.list.coach": "Exclusieve toegang tot een <strong>diabetescoach</strong>",
  "bundleProduct.description.list.dkv_coach_1": "",
  "bundleProduct.description.list.entry_search": "",
  "bundleProduct.description.list.guide": "Verbonden Accu-Chek® Guide <strong>bloedglucosemeter</strong>",
  "bundleProduct.description.list.guide_me": "Verbonden Accu-Chek® Guide Me <strong>bloedglucosemeter</strong>",
  "bundleProduct.description.list.meal_photos": "",
  "bundleProduct.description.list.pdf_report": "",
  "bundleProduct.description.list.pro": "Opgewaardeerd naar <strong>mySugr PRO app</strong>",
  "bundleProduct.description.list.pro.dkv": "Opgewaardeerd naar <strong>mySugr PRO app</strong>",
  "bundleProduct.description.list.pro.roche-benefits-us": "",
  "bundleProduct.description.list.pro.roche-benefits-us-coach": "",
  "bundleProduct.description.list.reminders": "",
  "bundleProduct.description.list.scale_1": "",
  "bundleProduct.description.list.schwenninger_coach_1": "Exclusieve toegang tot een <strong>lifestyle coach</strong>",
  "bundleProduct.description.list.strips_subscription_guide": "<strong>Onbeperkte teststrips</strong>, verzonden op basis van je gebruik (geïmporteerde bloedsuikermetingen in de app)",
  "bundleProduct.description.list.strips_subscription_guide.2": "<strong>Onbeperkte teststrips</strong>, verzonden op basis van je gebruik (geïmporteerde bloedsuikermetingen in de app)",
  "bundleProduct.description.title": "Je diabetes is nu eenvoudiger geworden ...",
  "bundleProduct.description.title.dkv": "",
  "bundleProduct.description.title.dvg": "",
  "bundleProduct.features.items.immediate.coach": "In-app <strong>toegang tot je persoonlijke coach</strong>",
  "bundleProduct.features.items.immediate.dkv_coach_1": "",
  "bundleProduct.features.items.immediate.mysugr_coach_voucher_based_1": "In-app <strong>toegang tot je persoonlijke coach</strong>",
  "bundleProduct.features.items.immediate.mysugr_pro_1.dkv": "",
  "bundleProduct.features.items.immediate.pro": "mySugr App <strong>PRO-functies</strong>",
  "bundleProduct.features.items.immediate.schwenninger_coach_1": "<strong>mySugr Coach</strong> via de app",
  "bundleProduct.features.items.immediate.servidigest_coach_1": "",
  "bundleProduct.features.items.product.cuff": "<b>1x</b> bloeddrukmeter",
  "bundleProduct.features.items.product.fastclix_lancets": "<strong>102x lancetten</strong>",
  "bundleProduct.features.items.product.fastclix_lancets_2": "<strong>204x lancetten</strong>",
  "bundleProduct.features.items.product.fastclix_lancing_kit": "<strong>1x</strong> Accu-Chek FastClix <strong>prikpen</strong>",
  "bundleProduct.features.items.product.guide": "<strong>1x</strong> Accu-Chek® Guide <strong>meter</strong>",
  "bundleProduct.features.items.product.guide_me": "<strong>1x</strong> Accu-Chek® Guide Me <strong>meter</strong>",
  "bundleProduct.features.items.product.guide_strips": "<strong>:amountx teststrips</strong>",
  "bundleProduct.features.items.product.scale": "<b>1x</b> weegschaal",
  "bundleProduct.features.items.product.softclix_lancets": "<strong>:amountx 100 lancetten</strong>",
  "bundleProduct.features.items.product.softclix_lancing_kit": "<strong>1x</strong> Accu-Chek® Softclix <strong>prikpen</strong>",
  "bundleProduct.features.items.subscription.alt_text.strips_subscription_guide.2": "<strong>Automatische aanvulling van teststrips</strong> op basis van je geïmporteerde metingen (zonder lancetten)",
  "bundleProduct.features.items.subscription.aok_nordwest_coach_1": "",
  "bundleProduct.features.items.subscription.coach": "<strong>mySugr Coach</strong> via de app",
  "bundleProduct.features.items.subscription.dkv_coach_1": "",
  "bundleProduct.features.items.subscription.mysugr_coach_voucher_based_1": "<strong>mySugr Coach</strong> via de app",
  "bundleProduct.features.items.subscription.schwenninger_coach_1": "<strong>mySugr Coach</strong> via de app",
  "bundleProduct.features.items.subscription.servidigest_coach_1": "",
  "bundleProduct.features.items.subscription.strips_subscription_guide": "<strong>Automatische levering van teststrips</strong> op basis van je geïmporteerde metingen",
  "bundleProduct.features.items.subscription.strips_subscription_guide.2": "<strong>Onbeperkte levering van teststrips</strong> op basis van je geïmporteerde metingen",
  "bundleProduct.features.title": "Je bundel omvat:",
  "bundleProduct.features.title.dkv": "",
  "bundleProduct.features.title.roche-benefits-us": "",
  "bundleProduct.features.title.roche-benefits-us-coach": "",
  "bundleProduct.features.titles.immediate": "Onmiddellijke toegang tot:",
  "bundleProduct.features.titles.product": "Binnen enkele dagen arriveert je verpakking met:",
  "bundleProduct.features.titles.subscription": "Continue toegang tot:",
  "bundleProduct.freeShipping": "Gratis verzending",
  "bundleProduct.groupNotFound": "Deze bundel is nu niet beschikbaar.",
  "bundleProduct.minCommitment.info.DAY.1": "Toezegging voor 1 dag is vereist",
  "bundleProduct.minCommitment.info.DAY.2": "Toezegging voor :minRecurringCount dagen is vereist",
  "bundleProduct.minCommitment.info.MONTH.1": "Toezegging voor 1 maand is vereist",
  "bundleProduct.minCommitment.info.MONTH.2": "Toezegging voor :minRecurringCount maand is vereist",
  "bundleProduct.minCommitment.info.WEEK.1": "",
  "bundleProduct.minCommitment.info.YEAR.1": "Toezegging voor 1 jaar is vereist",
  "bundleProduct.minCommitment.info.YEAR.2": "Toezegging voor :minRecurringCount jaar is vereist",
  "bundleProduct.noBundle.button": "Probeer het opnieuw",
  "bundleProduct.noBundle.text": "Sorry, we konden geen informatie over de bundel laden.",
  "bundleProduct.paymentInterval.DAY.1.long": "Elke dag",
  "bundleProduct.paymentInterval.DAY.1.short": "Dagelijks:",
  "bundleProduct.paymentInterval.DAY.2+": "Elke :intervalCount dagen",
  "bundleProduct.paymentInterval.MONTH.1.long": "Elke maand",
  "bundleProduct.paymentInterval.MONTH.1.short": "Maandelijks:",
  "bundleProduct.paymentInterval.MONTH.2+": "Elke :intervalCount maanden",
  "bundleProduct.paymentInterval.WEEK.1.long": "",
  "bundleProduct.paymentInterval.WEEK.1.short": "",
  "bundleProduct.paymentInterval.YEAR.1.long": "Elk jaar",
  "bundleProduct.paymentInterval.YEAR.1.short": "Jaarlijks:",
  "bundleProduct.paymentInterval.YEAR.2+": "Elke :intervalCount jaar",
  "bundleProduct.price": ":price",
  "cancelAnytime": "Je kunt je op elk moment uitschrijven voor mySugr.",
  "changeCardDetails": "Kaartgegevens wijzigen",
  "coachBox.text": "Meld je aan bij de app om je bericht te lezen en profiteer maximaal van je nieuwe, op jou afgestemde diabetesondersteuning.",
  "coachBox.title": "Je <b>persoonlijke coach</b> heeft je een bericht gestuurd!",
  "coachSelection.message.en": "Hello, <br>\nI am your <br>\npersonal <br>\ncoach!",
  "coachSelection.message.es": "Hola,<br>\nsoy tu<br>\n¡entrenador<br>\npersonal!",
  "coachSelection.select.button.en": "Select",
  "coachSelection.select.button.es": "Seleccionar",
  "coachSelection.subtitle": "Welke taal zou je willen spreken met je coach?",
  "coachSelection.title": "<strong>Selecteer je coach-taal</strong>",
  "confirmEmailCodeInputLabel": "Voer hier de code in die je per e-mail hebt ontvangen",
  "contact.stepName": "Contact",
  "contact.title": "<strong>Contact</strong>gegevens",
  "continueToNextStep": "Doorgaan naar volgende stap",
  "cookieBanner.allowAllButton": "Alles accepteren",
  "cookieBanner.cookieSettingsButton": "Cookie-instellingen",
  "cookieBanner.noticeDescription": "<p> We gebruiken cookies om onze site zo goed mogelijk te laten functioneren en om jou een eersteklas online ervaring te bieden! Door op “Alles accepteren” te klikken, ga je ermee akkoord dat cookies op je apparaat worden opgeslagen, om de navigatie op de website te verbeteren, het gebruik te analyseren en om te helpen bij onze marketinginspanningen. Om precies te kiezen welke categorieën je wilt toestaan, ga je naar “Cookie-instellingen”. <a href=\"https://legal.mysugr.com/documents/privacy_policy_web/current/en.html\" rel=\"noopener noreferrer\" target=\"_blank\"><strong style=\"color: #538400;\">Meer ontdekken</strong></a>.</p>",
  "cookieBanner.rejectAllButton": "Optionele cookies weigeren",
  "cookieBanner.title": "Mjam, mjam, we houden van koekjes!",
  "cookieBar.buttonText": "OK",
  "cookieBar.text": "We gebruiken cookies om onze website te optimaliseren en continu te verbeteren. Raadpleeg onze <a target=\"_blank\" rel=\"noopener\" href=\":link\" tabindex=\":tabIndex\">privacyverklaring</a> voor meer informatie over cookies en hoe je deze accepteert of weigert.",
  "cookieBar.text.global": "We gebruiken cookies om onze website te optimaliseren en continu te verbeteren. Raadpleeg onze privacyverklaring (<a target=\"_blank\" rel=\"noopener\" href=\":linkUs\" tabindex=\":tabIndex\">VS</a>, <a target=\"_blank\" rel=\"noopener\" href=\":linkEu\" tabindex=\":tabIndex\">EU</a>) voor meer informatie over cookies en hoe u deze accepteert of weigert.",
  "cookieCategory.functionalDescription": "Functionele verwerking & cookies voorzien onze webpagina's van betere functionaliteit en van personalisatie. Met jouw toestemming kunnen cookies door ons worden ingesteld of door externe serviceproviders die aan onze pagina's zijn toegevoegd. Als je deze cookies weigert, werken sommige services van ons of van externe providers mogelijk niet correct.",
  "cookieCategory.functionalTitle": "Functionele cookies",
  "cookieCategory.performanceDescription": "Prestatiecookies & verwerking stellen ons in staat om bezoeken en verkeersbronnen te tellen, zodat we de prestaties van onze webpagina's kunnen meten en verbeteren. Deze cookies helpen ons te begrijpen hoe onze webpagina's worden gebruikt, zoals bijvoorbeeld welke webpagina's het meest en minst populair zijn en hoe mensen door de webpagina's navigeren. De informatie die in deze cookies wordt verzameld, wordt met info van andere gebruikers gecombineerd, wat betekent dat ze niet persoonlijk op u terug te voeren zijn. Als u deze categorie niet toestaat, kunnen we niet zien wanneer u onze webpagina's hebt bezocht en kunnen we de prestaties van webpagina's niet volgen. In sommige gevallen kunnen deze cookies naar onze externe serviceproviders worden verzonden om ons te helpen bij analyses.",
  "cookieCategory.performanceTitle": "Prestatiecookies",
  "cookieCategory.socialMediaDescription": "Met jouw toestemming worden cookies van meerdere sociale media ingesteld die we aan de webpagina hebben toegevoegd (zoals Facebook, Twitter, LinkedIn), zodat je onze inhoud kunt delen met je vrienden, collega's en netwerken. Deze cookies kunnen je browser volgen op andere sites van derden en kunnen een profiel van je interesses opbouwen. Dat kan van invloed zijn op de inhoud en berichten die je ziet op de andere sites van derden die je bezoekt. Als je geen toestemming geeft voor deze cookies, is het mogelijk dat je deze functies om te delen niet kunt gebruiken of zien.",
  "cookieCategory.socialMediaTitle": "Cookies van sociale media",
  "cookieCategory.strictlyNecessaryDescription": "Strikt noodzakelijke verwerking & cookies zijn nodig om de webpagina's te laten functioneren en kunnen niet worden uitgeschakeld. Deze cookies worden alleen ingesteld als reactie op door jou ondernomen acties, zoals het verzoeken om diensten, het instellen van je privacy- en cookievoorkeuren, het inloggen en het invullen van formulieren. Je kunt je browser zo instellen dat deze worden geblokkeerd of een waarschuwing uitlokken, maar als je deze cookies blokkeert, werken de webpagina's niet.",
  "cookieCategory.strictlyNecessaryTitle": "Strikt noodzakelijke cookies",
  "cookieCategory.targetingDescription": "Met jouw toestemming kunnen doelgerichte cookies door onze advertentiepartners worden geëvalueerd of op onze webpagina worden geplaatst. Ze kunnen door die bedrijven worden gebruikt om een profiel van je interesses op te bouwen en om relevante advertenties op andere webpagina's te laten zien. Deze cookies slaan niet direct persoonlijke informatie op, maar zijn gebaseerd op een unieke identificatie van je browser en internetapparaat. Als je geen toestemming geeft voor deze cookies, krijgt je minder gerichte advertenties te zien. mySugr gebruikt deze cookies om het succes bij te houden van digitale marketingcampagnes die onze producten en diensten promoten.",
  "cookieCategory.targetingTitle": "Doelgerichte cookies",
  "cookieList.category": "Categorie",
  "cookieList.description": "Beschrijving",
  "cookieList.duration": "Tijdsduur",
  "cookieList.host": "Host",
  "cookieList.name": "Naam",
  "cookieList.type": "Type",
  "cookiePreferenceCenter.allowAllButton": "Alle cookies accepteren",
  "cookiePreferenceCenter.alwaysActiveTitle": "Altijd actief",
  "cookiePreferenceCenter.categoriesTitle": "Toestemmingsvoorkeuren beheren",
  "cookiePreferenceCenter.confirmButton": "Geselecteerde cookies accepteren",
  "cookiePreferenceCenter.cookieListLink": "Cookie-gegevens",
  "cookiePreferenceCenter.cookiePolicyLink": "Je kunt de volledige privacy- en cookieverklaring van mySugr-webpagina's hier vinden.",
  "cookiePreferenceCenter.cookiesListTitle": "Lijst met cookies",
  "cookiePreferenceCenter.description": "In het Centrum met privacyvoorkeuren kun je cookie-categorieën activeren; je kunt deze instellingen op elk moment wijzigen.\nAls je de instellingen in de toekomst wilt wijzigen, gebruik dan de link Cookie-instellingen onderaan op de webpagina.",
  "cookiePreferenceCenter.firstPartyCookies": "Eigen cookies",
  "cookiePreferenceCenter.optionalGroupName": "Optioneel",
  "cookiePreferenceCenter.rejectAllButton": "Optionele cookies weigeren",
  "cookiePreferenceCenter.strictlyNecessaryGroupName": "Strikt noodzakelijk",
  "cookiePreferenceCenter.title": "Centrum met privacyvoorkeuren",
  "cookiePreferenceCenter.viewCookiesButton": "Cookies weergeven",
  "countres.gu": "Guam",
  "countries.ad": "Andorra",
  "countries.ae": "Verenigde Arabische Emiraten",
  "countries.af": "Afghanistan",
  "countries.ag": "Antigua en Barbuda",
  "countries.ai": "Anguilla",
  "countries.al": "Albanië",
  "countries.am": "Armenië",
  "countries.ao": "Angola",
  "countries.aq": "Antarctica",
  "countries.ar": "Argentinië",
  "countries.as": "Amerikaans-Samoa",
  "countries.at": "Oostenrijk",
  "countries.au": "Australië",
  "countries.aw": "Aruba",
  "countries.ax": "Åland-eilanden",
  "countries.az": "Azerbeidzjan",
  "countries.ba": "Bosnië en Herzegovina",
  "countries.bb": "Barbados",
  "countries.bd": "Bangladesh",
  "countries.be": "België",
  "countries.bf": "Burkina Faso",
  "countries.bg": "Bulgarije",
  "countries.bh": "Bahrein",
  "countries.bi": "Burundi",
  "countries.bj": "Benin",
  "countries.bl": "Saint-Barthélemy",
  "countries.bm": "Bermuda",
  "countries.bn": "Brunei Darussalam",
  "countries.bo": "Bolivia",
  "countries.bq": "Bonaire",
  "countries.br": "Brazilië",
  "countries.bs": "Bahama's",
  "countries.bt": "Bhutan",
  "countries.bv": "Bouveteiland",
  "countries.bw": "Botswana",
  "countries.by": "Wit-Rusland",
  "countries.bz": "Belize",
  "countries.cc": "Cocoseilanden (Keelingeilanden)",
  "countries.cd": "Congo, Democratische Republiek",
  "countries.cf": "Centraal-Afrikaanse Republiek",
  "countries.cg": "Congo",
  "countries.ch": "Zwitserland",
  "countries.ci": "Ivoorkust",
  "countries.ck": "Cookeilanden",
  "countries.cl": "Chili",
  "countries.cm": "Kameroen",
  "countries.cn": "Canada",
  "countries.co": "Colombia",
  "countries.cr": "Costa Rica",
  "countries.cu": "Cuba",
  "countries.cv": "Kaapverdië",
  "countries.cw": "Curaçao",
  "countries.cx": "Christmaseiland",
  "countries.cy": "Cyprus",
  "countries.cz": "Tsjechische Republiek",
  "countries.de": "Duitsland",
  "countries.dj": "Djibouti",
  "countries.dk": "Denemarken",
  "countries.dm": "Dominica",
  "countries.do": "Dominicaanse Republiek",
  "countries.dz": "Algerije",
  "countries.ec": "Ecuador",
  "countries.ee": "Estland",
  "countries.eg": "Egypte",
  "countries.eh": "Westelijke Sahara",
  "countries.er": "Eritrea",
  "countries.es": "Spanje",
  "countries.et": "Ethiopië",
  "countries.fi": "Finland",
  "countries.fj": "Fiji",
  "countries.fk": "Falklandeilanden",
  "countries.fm": "Micronesia, Federale Staten van",
  "countries.fo": "Faeröer",
  "countries.fr": "Frankrijk",
  "countries.ga": "Gabon",
  "countries.gb": "Verenigd Koninkrijk",
  "countries.gd": "Grenada",
  "countries.ge": "Georgië",
  "countries.gf": "Frans-Guyana",
  "countries.gg": "Guernsey",
  "countries.gh": "Ghana",
  "countries.gi": "Gibraltar",
  "countries.gl": "Groenland",
  "countries.gm": "Gambia",
  "countries.gn": "Guinee",
  "countries.gp": "Guadeloupe",
  "countries.gq": "Equatoriaal-Guinea",
  "countries.gr": "Griekenland",
  "countries.gs": "Zuid-Georgië en de Zuidelijke Sandwicheilanden",
  "countries.gt": "Guatemala",
  "countries.gw": "Guinee-Bissau",
  "countries.gy": "Guyana",
  "countries.hk": "Hongkong",
  "countries.hm": "Heard en McDonaldeilanden",
  "countries.hn": "Honduras",
  "countries.hr": "Kroatië",
  "countries.ht": "Haïti",
  "countries.hu": "Hongarije",
  "countries.id": "Indonesië",
  "countries.ie": "Ierland",
  "countries.il": "Israël",
  "countries.im": "Eiland Man",
  "countries.in": "India",
  "countries.io": "Brits Indische Oceaanterritorium",
  "countries.iq": "Irak",
  "countries.ir": "Iran, Islamitische Republiek",
  "countries.is": "IJsland",
  "countries.it": "Italië",
  "countries.je": "Jersey",
  "countries.jm": "Jamaica",
  "countries.jo": "Jordanië",
  "countries.jp": "Japan",
  "countries.ke": "Kenia",
  "countries.kg": "Kirgizië",
  "countries.kh": "Cambodja",
  "countries.ki": "Kiribati",
  "countries.km": "Comoren",
  "countries.kn": "Saint Kitts en Nevis",
  "countries.kp": "Korea, Democratische Volksrepubliek",
  "countries.kr": "Korea, Republiek",
  "countries.kw": "Koeweit",
  "countries.ky": "Kaaimaneilanden",
  "countries.kz": "Kazachstan",
  "countries.la": "Laos, Democratische Volksrepubliek",
  "countries.lb": "Libanon",
  "countries.lc": "Saint Lucia",
  "countries.li": "Liechtenstein",
  "countries.lk": "Sri Lanka",
  "countries.lr": "Liberia",
  "countries.ls": "Lesotho",
  "countries.lt": "Litouwen",
  "countries.lu": "Luxemburg",
  "countries.lv": "Letland",
  "countries.ly": "Libië",
  "countries.ma": "Marokko",
  "countries.mc": "Monaco",
  "countries.md": "Moldavië, Republiek",
  "countries.me": "Montenegro",
  "countries.mf": "Sint-Maarten (franse deel)",
  "countries.mg": "Madagaskar",
  "countries.mh": "Marshalleilanden",
  "countries.mk": "Macedonië, de voormalige Joegoslavische Republiek",
  "countries.ml": "Mali",
  "countries.mm": "Myanmar",
  "countries.mn": "Mongolië",
  "countries.mo": "Macau",
  "countries.mp": "Noordelijke Marianen",
  "countries.mq": "Martinique",
  "countries.mr": "Mauritanië",
  "countries.ms": "Montserrat",
  "countries.mt": "Malta",
  "countries.mu": "Mauritius",
  "countries.mv": "Malediven",
  "countries.mw": "Malawi",
  "countries.mx": "Mexico",
  "countries.my": "Maleisië",
  "countries.mz": "Mozambique",
  "countries.na": "Namibië",
  "countries.nc": "Nieuw-Caledonië",
  "countries.ne": "Niger",
  "countries.nf": "Norfolkeiland",
  "countries.ng": "Nigeria",
  "countries.ni": "Nicaragua",
  "countries.nl": "Nederland",
  "countries.no": "Noorwegen",
  "countries.np": "Nepal",
  "countries.nr": "Nauru",
  "countries.nu": "Niue",
  "countries.nz": "Nieuw-Zeeland",
  "countries.om": "Oman",
  "countries.pa": "Panama",
  "countries.pe": "Peru",
  "countries.pf": "Frans-Polynesië",
  "countries.pg": "Papoea-Nieuw-Guinea",
  "countries.ph": "Filipijnen",
  "countries.pk": "Pakistan",
  "countries.pl": "Polen",
  "countries.pm": "Saint-Pierre en Miquelon",
  "countries.pn": "Pitcairneilanden",
  "countries.pr": "Puerto Rico",
  "countries.ps": "Palestina",
  "countries.pt": "Portugal",
  "countries.pw": "Palau",
  "countries.py": "Paraguay",
  "countries.qa": "Qatar",
  "countries.re": "Réunion",
  "countries.ro": "Roemenië",
  "countries.rs": "Servië",
  "countries.ru": "Russische Federatie",
  "countries.rw": "Rwanda",
  "countries.sa": "Saoedi-Arabië",
  "countries.sb": "Salomonseilanden",
  "countries.sc": "Seychellen",
  "countries.sd": "Soedan",
  "countries.se": "Zweden",
  "countries.sg": "Singapore",
  "countries.sh": "Sint-Helena, Ascension en Tristan da Cunha",
  "countries.si": "Slovenië",
  "countries.sj": "Spitsbergen en Jan Mayen",
  "countries.sk": "Slowakije",
  "countries.sl": "Sierra Leone",
  "countries.sm": "San Marino",
  "countries.sn": "Senegal",
  "countries.so": "Somalië",
  "countries.sr": "Suriname",
  "countries.ss": "Zuid-Soedan",
  "countries.st": "Sao Tomé en Principe",
  "countries.sv": "El Salvador",
  "countries.sx": "Sint-Maarten (nederlands deel)",
  "countries.sy": "Arabische Republiek Syrië",
  "countries.sz": "Swaziland",
  "countries.tc": "Turks- en Caicoseilanden",
  "countries.td": "Tsjaad",
  "countries.tf": "Franse Zuidelijke Gebieden",
  "countries.tg": "Togo",
  "countries.th": "Thailand",
  "countries.tj": "Tadzjikistan",
  "countries.tk": "Tokelau",
  "countries.tl": "Timor-Leste",
  "countries.tm": "Turkmenistan",
  "countries.tn": "Tunesië",
  "countries.to": "Tonga",
  "countries.tr": "Turkije",
  "countries.tt": "Trinidad en Tobago",
  "countries.tv": "Tuvalu",
  "countries.tw": "Taiwan",
  "countries.tz": "Tanzania, Verenigde Republiek",
  "countries.ua": "Oekraïne",
  "countries.ug": "Oeganda",
  "countries.um": "Kleine afgelegen eilanden van de Verenigde Staten",
  "countries.us": "Verenigde Staten",
  "countries.uy": "Uruguay",
  "countries.uz": "Oezbekistan",
  "countries.va": "Vaticaanstad",
  "countries.vc": "Saint Vincent en de Grenadines",
  "countries.ve": "Venezuela, Bolivariaanse Republiek",
  "countries.vg": "Maagdeneilanden, Britse",
  "countries.vi": "Maagdeneilanden, Amerikaanse",
  "countries.vn": "Vietnam",
  "countries.vu": "Vanuatu",
  "countries.wf": "Wallis en Futuna",
  "countries.ws": "Samoa",
  "countries.ye": "Jemen",
  "countries.yt": "Mayotte",
  "countries.za": "Zuid-Afrika",
  "countries.zm": "Zambia",
  "countries.zw": "Zimbabwe",
  "countryNames.de.long": "Duitsland",
  "countryNames.de.medium": "Duitsland",
  "countryNames.de.short": "DE",
  "countryNames.us.long": "Verenigde Staten van Amerika",
  "countryNames.us.medium": "VS",
  "countryNames.us.short": "VS",
  "cta.redeemVoucher": "Tegoedbon inwisselen",
  "cta.unlockFree": "Gratis ontgrendeling",
  "customCodeVerificationForm.label.dvg": "",
  "customCodeVerificationForm.label.optumrx_1": "OptumRX-ID",
  "customCodeVerificationForm.overlayButtonText": "Meer informatie",
  "customCodeVerificationForm.overlayText.dvg": "",
  "customCodeVerificationForm.overlayText.optumrx_1": "",
  "customCodeVerificationForm.placeholder.dvg": " ",
  "customCodeVerificationForm.placeholder.optumrx_1": " ",
  "downloadApp.desktop.text": "Richt de camera van je smartphone op <br> de onderstaande QR-code om de app te downloaden",
  "downloadApp.mobile.text": "Je kunt de app downloaden op:",
  "downloadApp.text": "Om je registratie te voltooien: <b>download de mySugr app</b> uit de app-store van je telefoon en log in met je e-mailadres.",
  "downloadApp.title": "<b>Nog een laatste ding!</b>",
  "eligibilityCheck.failure.changeEmailButton": "E-mailadres wijzigen",
  "eligibilityCheck.failure.monsterAlt": "",
  "eligibilityCheck.failure.title": "",
  "eligibilityCheck.failure.unsuccessfulText": "",
  "eligibilityCheck.form.companyEmail.label": "",
  "eligibilityCheck.form.continue": "",
  "eligibilityCheck.form.overlayText": "<p>Voer het e-mailadres in dat je van je werkgever hebt gekregen, zodat we kunnen controleren of je in aanmerking komt voor de mySugr Bundel.</p>\n\n<p>Als je in aanmerking komt voor de mySugr Bundel, ontvang je van ons een e-mail met een link om je in te schrijven voor de bundel.</p>\n\n<p>We gebruiken je e-mailadres van je werkgever alleen om te controleren of je in aanmerking komt. Wanneer je inschrijving voor het programma is voltooid, kunt je naar wens doorgaan met dat mySugr account of een nieuw mySugr account aanmaken met een ander e-mailadres.</p>",
  "eligibilityCheck.introText": "",
  "eligibilityCheck.pageTitle": "",
  "eligibilityCheck.resend.notification.failure": "We konden de e-mail met acceptatie-bevestiging niet opnieuw versturen.",
  "eligibilityCheck.resend.notification.success": "We hebben de e-mail met acceptatie-bevestiging opnieuw verstuurd.",
  "eligibilityCheck.success.boxAlt": "",
  "eligibilityCheck.success.boxWithHeartAlt": "Hart dat uit een doos springt",
  "eligibilityCheck.success.changeEmailButton": "E-mail wijzigen",
  "eligibilityCheck.success.resendButton": "E-mail opnieuw verzenden",
  "eligibilityCheck.success.resendText": "Heb je de tegoedboncode niet ontvangen?",
  "eligibilityCheck.success.successfullText": "Je organisatie dekt de mySugr Bundel.<br>\nWe hebben je een tegoedboncode gestuurd waarmee jij je in kunt schrijven.",
  "eligibilityCheck.success.title": "Het e-mailadres komt in aanmerking voor de mySugr Bundel",
  "eligibilityCheck.title": "",
  "email.stepName": "Registratie / Login",
  "endsWithNumber": "Eindigt met:",
  "enroll": "Inschrijven",
  "errors.ADYEN_REFUSED_3D_NOT_AUTHENTICATED": "Identificatie met 3D-beveiliging is mislukt of geannuleerd",
  "errors.ADYEN_REFUSED_3D_SECURE_AUTHENTICATION_FAILED": "Identificatie met 3D-beveiliging is mislukt",
  "errors.ADYEN_REFUSED_CVC_DECLINED": "CVC werd geweigerd",
  "errors.ADYEN_REFUSED_EXPIRED_CARD": "Kaart is verlopen.",
  "errors.ADYEN_REFUSED_FRAUD": "Er is een probleem met je creditcard.",
  "errors.ADYEN_REFUSED_INVALID_CARD_NUMBER": "Kaartnummer is ongeldig.",
  "errors.ADYEN_REFUSED_REFUSED": "Creditcard is geweigerd",
  "errors.ASSIGN_OPTUM_RX_ERROR.invalid_input": "De OptumRx-patiënt-ID is ongeldig",
  "errors.ASSIGN_OPTUM_RX_ERROR.patient_already_assigned": "De OptumRx-patiënt-ID is al gebruikt",
  "errors.CARD_DECLINED": "Kaart is geweigerd.",
  "errors.CARD_NOT_SUPPORTED.cardNumber": "Je kaart wordt niet ondersteund.",
  "errors.COUNTRY_REGION_MISSMATCH": "De aanbieding die je probeert in te wisselen, is momenteel niet beschikbaar in :nameCountry. De aanbieding is alleen beschikbaar voor gebruikers die hun gegevens opslaan in :offerRegions. Neem contact op met ondersteuning.",
  "errors.DECLINED_CARD.cardNumber": "Kaart is geweigerd.",
  "errors.EMPTY_CART": "Je winkelwagen is leeg. Je moet een bundel selecteren voordat je kunt inschrijven.",
  "errors.EXISTS_IN_OTHER_REGION": "De tegoedbon is al ingewisseld of je gebruikersgegevens zijn opgeslagen in een andere regio dan de aanbieding. Neem contact op met ondersteuning.",
  "errors.EXPIRED_CARD.cardNumber": "Kaart is verlopen.",
  "errors.INCOMPLETE_CARD_CVC.cvc": "CVC/CVV is verplicht.",
  "errors.INCOMPLETE_CARD_EXPIRATION.expiration": "Vervaldatum van de kaart is verplicht.",
  "errors.INCOMPLETE_CARD_NUMBER.cardNumber": "Kaartnummer is verplicht.",
  "errors.INCORRECT_CVC": "De CVC/CVV is niet correct.",
  "errors.INSUFFICIENT_FUNDS": "Je kaart is geweigerd omdat deze onvoldoende saldo heeft.",
  "errors.INVALID_AGE.birthdate": "Je moet :minAge+ jaar of ouder zijn om je in te schrijven",
  "errors.INVALID_BIRTHDATE.birthdate": "Geboortedatum is niet geldig",
  "errors.INVALID_CARD_CVC_NUMBER.cvc": "CVC/CVV is niet correct",
  "errors.INVALID_CARD_EXPIRATION_MONTH_PAST.expiration": "Vervalmaand ligt in het verleden.",
  "errors.INVALID_CARD_EXPIRATION_YEAR_PAST.expiration": "Vervaljaar ligt in het verleden.",
  "errors.INVALID_CARD_NUMBER.cardNumber": "Kaartnummer is ongeldig.",
  "errors.INVALID_COUNTRY": "Dit aanbod is niet verenigbaar met het land dat aan je gebruiker is gekoppeld. Neem contact op met ondersteuning om dit probleem op te lossen.",
  "errors.INVALID_EMAIL_CONFIRMATION_CODE.code": "Ongeldige e-mailbevestigingscode",
  "errors.INVALID_EMAIL.companyEmail": "E-mailadres is niet geldig",
  "errors.INVALID_EMAIL.email": "E-mailadres is niet geldig",
  "errors.INVALID_GERMAN_STATE.state": "Selecteer een provincie.",
  "errors.INVALID_INSURANCE_CARD_INFO.groupNumber": "Ongeldig nummer",
  "errors.INVALID_INSURANCE_CARD_INFO.memberId": "Ongeldig ID",
  "errors.INVALID_INSURANCE_NUMBER.insuranceNumber": "Ongeldig verzekeringsnummer",
  "errors.INVALID_LOGIN": "E-mailadres en wachtwoord komen niet overeen met een mySugr gebruiker",
  "errors.INVALID_PASSWORD_CONFIRMATION.password2": "Wachtwoordbevestiging komt niet overeen met wachtwoord.",
  "errors.INVALID_PHONE_NUMBER.phone": "Telefoonnummer is niet geldig",
  "errors.INVALID_POSTAL_CODE.postalCode": "Postcode is niet geldig",
  "errors.INVALID_US_STATE.state": "Selecteer een staat.",
  "errors.INVALID_VOUCHER_CODE.voucherCode": "Ongeldig",
  "errors.INVALID_ZIP_CODE.postalCode": "Postcode is niet geldig",
  "errors.INVALID.customCodeVerification": "Ongeldige ID",
  "errors.INVALID.customCodeVerification.dvg": "",
  "errors.MIN_LENGTH.password": "Wachtwoord moet minimaal :minLength tekens bevatten.",
  "errors.MIN_LENGTH.password2": "Wachtwoord moet minimaal :minLength tekens bevatten.",
  "errors.MISSING_CONSENT.consents": "Je moet de :title accepteren.",
  "errors.MISSING_CONSENTS": "We kunnen je bestelling niet verwerken. Neem contact op met support@mysugr.com",
  "errors.MISSING_CONSENTS_FAILED": "We kunnen je bestelling niet verwerken. Neem contact op met support@mysugr.com",
  "errors.MISSING_FIELD.address": "Adres is verplicht",
  "errors.MISSING_FIELD.birthdate": "Geboortedatum is vereist",
  "errors.MISSING_FIELD.birthdateCheckbox": "Deelnemers moeten voldoen aan de vereiste minimumleeftijd om zich te abonneren",
  "errors.MISSING_FIELD.city": "Stad is verplicht",
  "errors.MISSING_FIELD.companyEmail": "E-mailadres is verplicht",
  "errors.MISSING_FIELD.country": "Land is verplicht",
  "errors.MISSING_FIELD.email": "E-mailadres is verplicht",
  "errors.MISSING_FIELD.employer": "Selecteer een werkgever",
  "errors.MISSING_FIELD.firstName": "Voornaam is verplicht",
  "errors.MISSING_FIELD.lastName": "Achternaam is verplicht",
  "errors.MISSING_FIELD.name": "Naam is verplicht",
  "errors.MISSING_FIELD.password": "Voer een wachtwoord in",
  "errors.MISSING_FIELD.password2": "Herhaal het wachtwoord",
  "errors.MISSING_FIELD.phone": "Telefoonnummer is verplicht",
  "errors.MISSING_FIELD.postalCode": "Postcode is verplicht",
  "errors.MISSING_FIELD.state": "Staat is verplicht",
  "errors.MISSING_FIELD.voucherCode": "Voer de code van je tegoedbon in",
  "errors.PASSWORD_RESET_TOKEN_EXPIRED": "Het token voor het opnieuw instellen van het wachtwoord is verlopen.",
  "errors.PAYMENT_DETAILS_NOT_SUPPORTED": "Kaarttype wordt niet ondersteund.",
  "errors.POSSIBLE_PO_BOX.address": "Dit adres lijkt op een postbus. Om wettelijke redenen kunnen we niet leveren aan postbussen.",
  "errors.PRESCRIPTION_ALREADY_ACTIVE": "",
  "errors.PROCESSING_ERROR": "We kunnen je kaart niet verwerken.",
  "errors.SERVER_ERROR": "Fout bij contact maken met mySugr server",
  "errors.STRIPE_ERROR": "Kan betaling niet initialiseren",
  "errors.THE_VOUCHER_IS_CURRENTLY_NOT_ACTIVE.voucherCode": "Deze tegoedbon is nu niet actief",
  "errors.undefined": "Ongedefinieerde fout",
  "errors.UNKNOWN_ERROR": "Er is iets fout gegaan.",
  "errors.UNKNOWN_ERROR_2": "Oeps, er is iets fout gegaan",
  "errors.UNLOCK_CODE_ALREADY_USED": "Deze activeringscode is al gebruikt.",
  "errors.UNLOCK_CODE_INVALID": "",
  "errors.USER_ALREADY_SUBSCRIBED_TO_BUNDLE": "Je bent al ingeschreven voor de mySugr Bundel.",
  "errors.USER_ALREADY_SUBSCRIBED_TO_PLAN": "Je bent al ingeschreven voor de mySugr Bundel.",
  "errors.USER_EMAIL_HAS_ACTIVE_BUNDLE": "Je bent al ingeschreven voor de mySugr Bundel met dit e-mailadres.",
  "errors.USER_EMAIL_HAS_ACTIVE_PRESCRIPTION": "",
  "errors.USER_EXISTS.email": "Gebruiker bestaat al",
  "errors.USER_HAS_NO_BUNDLE": "Het wijzigen van betalingsgegevens is alleen beschikbaar als je een actief mySugr Bundel-abonnement hebt.",
  "errors.USER_HAS_NO_EXISTING_PAYMENT": "Geen betalingsgegevens gevonden",
  "errors.USER_MISSING": "Er was een probleem met je abonnement.\nNeem contact op met klantenondersteuning.",
  "errors.VOUCHER_ALREADY_EXPIRED.voucherCode": "Deze tegoedbon is verlopen",
  "errors.VOUCHER_ALREADY_REDEEMED": "De tegoedbon is al ingewisseld voor dit account",
  "errors.VOUCHER_DOES_NOT_EXISTS.voucherCode": "Deze tegoedbon bestaat niet",
  "errors.VOUCHER_MAXIMUM_REDEMPTION_EXCEEDED": "Deze tegoedcode is al te vaak gebruikt en is niet langer geldig.",
  "errors.VOUCHER_MAXIMUM_REDEMPTION_EXCEEDED.voucherCode": "Deze tegoedcode is al te vaak gebruikt en is niet langer geldig.",
  "footer.callSupport": "Bel gratis: <strong>:phone</strong>",
  "footer.happyToHelp": "We helpen je graag verder:",
  "footer.headline": "Vragen over je bestelling?",
  "footer.legalNotice.activision_blizzard_1": "",
  "footer.legalNotice.allianz_1": "",
  "footer.legalNotice.aok_1": "",
  "footer.legalNotice.aok_nordwest_1": "",
  "footer.legalNotice.barmenia_1": "",
  "footer.legalNotice.barmer_1": "",
  "footer.legalNotice.bi_state_development_1": "",
  "footer.legalNotice.buchanan_us_1": "",
  "footer.legalNotice.dkv_1": "",
  "footer.legalNotice.ed_voyles_1": "",
  "footer.legalNotice.garfield_county_1": "",
  "footer.legalNotice.genentech_1": "",
  "footer.legalNotice.gothaer_1": "",
  "footer.legalNotice.inter_1": "",
  "footer.legalNotice.jbz_1": "<p>Door voor het mySugr coaching platform te kiezen, bent u onderworpen aan onze <a href=\":tcsUrl\" target=\"_blank\" rel=\"noopener\">Algemene voorwaarden</a>, die hieronder worden verstrekt. \nAls u zich wilt afmelden, kunt u op elk gewenst moment een e-mail sturen naar <a href=\"mailto::email\">:email</a> waarna uw annuleringsverzoek wordt ingediend.</p>\n\n<p>De mySugr-app en mySugr Coach worden als een voucher verstrekt. Door de app te downloaden en het registratieproces uit te voeren, accepteert u de <a href=\":tcsUrl\" target=\"_blank\" rel=\"noopener\">Algemene voorwaarden</a> en de <a href=\":privacyPolicyUrl\" target=\"_blank\" rel=\"noopener\">Privacyverklaring van mySugr GmbH</a>. Deze website bevat informatie over producten die zijn gericht voor een breed publiek en kan productdetails of informatie bevatten die anders niet toegankelijk of geldig is in uw land. Houd er rekening mee dat we geen verantwoordelijkheid nemen voor toegang tot dergelijke informatie die mogelijk niet voldoet aan een geldig juridisch proces, regelgeving, registratie of gebruik in het land van herkomst. © 2020 mySugr, GmbH. Alle rechten voorbehouden. MYSUGR, ACCU-CHEK zijn handelsmerken van Roche. Alle andere productnamen en handelsmerken merken zijn eigendom van hun respectieve eigenaars.\n© 2020 Roche Diabetes Care.</p>",
  "footer.legalNotice.lazer_spot_1": "",
  "footer.legalNotice.mastec_1": "",
  "footer.legalNotice.mmc_1": "<p>Door voor het mySugr coaching platform te kiezen, bent u onderworpen aan onze <a href=\":tcsUrl\" target=\"_blank\" rel=\"noopener\">Algemene voorwaarden</a>, die hieronder worden verstrekt. \nAls u zich wilt afmelden, kunt u op elk gewenst moment een e-mail sturen naar <a href=\"mailto::email\">:email</a> waarna uw annuleringsverzoek wordt ingediend.</p>\n\n<p>De mySugr-app en mySugr Coach worden als een voucher verstrekt. Door de app te downloaden en het registratieproces uit te voeren, accepteert u de <a href=\":tcsUrl\" target=\"_blank\" rel=\"noopener\">Algemene voorwaarden</a> en de <a href=\":privacyPolicyUrl\" target=\"_blank\" rel=\"noopener\">Privacyverklaring van mySugr GmbH</a>. Deze website bevat informatie over producten die zijn gericht voor een breed publiek en kan productdetails of informatie bevatten die anders niet toegankelijk of geldig is in uw land. Houd er rekening mee dat we geen verantwoordelijkheid nemen voor toegang tot dergelijke informatie die mogelijk niet voldoet aan een geldig juridisch proces, regelgeving, registratie of gebruik in het land van herkomst. © 2020 mySugr, GmbH. Alle rechten voorbehouden. MYSUGR, ACCU-CHEK zijn handelsmerken van Roche. Alle andere productnamen en handelsmerken merken zijn eigendom van hun respectieve eigenaars.\n© 2020 Roche Diabetes Care.</p>",
  "footer.legalNotice.optumrx_1": "",
  "footer.legalNotice.roche_ponce": "",
  "footer.legalNotice.roche_us_1": "",
  "footer.legalNotice.si_group_1": "",
  "footer.legalNotice.ukv_1": "",
  "footer.legalNotice.vkb_1": "",
  "footer.legalNotice.wth_1": "",
  "footer.links.imprint": "Afdrukken",
  "footer.links.privacyNotice": "Privacyverklaring",
  "footer.links.tcs": "Algemene voorwaarden",
  "footer.subscriptionLegalNotice": "MAANDELIJKSE BETALINGEN WORDEN NIET TERUGBETAALD. De mySugr Bundel werkt met een maandelijks abonnement en begint met een eerste minimale abonnementsperiode van drie (3) maanden. Automatische aanvulling van teststrips wordt naar behoefte verzonden, alleen wanneer je voorraad beperkt is [zoals berekend door de mySugr App op basis van waarden die door jou zijn geüpload naar de Accu-Chek® Guide meter]. Je komt niet in aanmerking voor deelname aan een door mySugr Inc. aangeboden abonnementsplan als je bent ingeschreven bij, of medische of receptvergoeding krijgt via, een overheidsprogramma, inclusief maar niet beperkt tot Medicare en Medicaid, of als deelname om een andere reden wettelijk verboden is. Door de mySugr Bundle te kiezen, ben je onderworpen aan onze volledige <a href=\"https://legal.mysugr.com/documents/BUNDLE_TERMS_AND_CONDITIONS_US/current.html\" target=\"_blank\" rel=\"noreferrer\"><strong>Algemene voorwaarden</strong></a>, hieronder weergegeven. Als je het abonnement wilt opzeggen, kun je <a href=\"mailto::email\">op elk gewenst moment een e-mail sturen naar :email</a>, waarna je annuleringsverzoek onmiddellijk wordt verwerkt.<br/>De mySugr App en mySugr Coach worden als voucher verstrekt. Door de app te downloaden en het registratieproces uit te voeren, accepteer je de <a href=\"https://legal.mysugr.com/documents/GENERAL_TERMS_OF_SERVICE/current.html\" target=\"_blank\" rel=\"noreferrer\"><strong>Algemene voorwaarden</strong></a> en de <a href=\"https://legal.mysugr.com/documents/PRIVACY_POLICY_US/current.html\" target=\"_blank\" rel=\"noreferrer\"><strong>Privacyverklaring</strong></a> van mySugr GmbH.<br />Deze website bevat informatie over producten die zijn bedoeld voor een breed publiek en kan productdetails of informatie bevatten die anderszins niet toegankelijk of geldig is in je land. Houd er rekening mee dat we geen verantwoordelijkheid nemen voor toegang tot informatie die mogelijk niet voldoet aan juridische procedures, regelgeving, registratie of gebruik in het land waar je woont. © 2018 mySugr, Inc. Alle rechten voorbehouden. MYSUGR, ACCU-CHEK en ACCU-CHEK GUIDE zijn merken van Roche. Alle overige productnamen en handelsmerken zijn het eigendom van hun respectieve eigenaars.<br />© :currentYear Roche Diabetes Care.",
  "footer.writeSupport": "Of schrijf eenvoudig naar: <a href=\"mailto::email\">:email</a>",
  "form.availableCountriesLabel": "Beschikbare landen",
  "groupSelection.continue": "Aan de slag",
  "groupSelection.items.description.alt_text.strips_subscription_guide.2": "<strong>Automatische aanvulling van teststrips</strong> op basis van je geïmporteerde metingen (zonder lancetten)",
  "groupSelection.items.description.coach": "Exclusieve toegang tot een <strong>diabetescoach</strong>",
  "groupSelection.items.description.guide": "Accu-Chek® Guide <strong>bloedglucosemeter</strong>",
  "groupSelection.items.description.guide_me_1": "Accu-Chek® Guide Me <strong>bloedglucosemeter</strong>",
  "groupSelection.items.description.pro": "<strong>mySugr app</strong> met <strong>PRO-functies</strong>",
  "groupSelection.items.description.scale_1": "",
  "groupSelection.items.description.strips_subscription_guide": "<strong>Automatische levering van teststrips</strong> op basis van je geïmporteerde metingen",
  "groupSelection.items.description.strips_subscription_guide.2": "<strong>Onbeperkte levering van teststrips</strong> op basis van je geïmporteerde metingen",
  "groupSelection.message.reimbursement.linkText": "Meer informatie",
  "groupSelection.message.reimbursement.linkText.dvg": "",
  "groupSelection.message.reimbursement.text": "Tot 100% vergoeding",
  "groupSelection.message.reimbursement.text.dkv": "",
  "groupSelection.message.reimbursement.text.dvg": "",
  "groupSelection.message.roche_bundle_group_coach_1": "",
  "groupSelection.message.roche_bundle_group_guide_1": "",
  "groupSelection.moreInfo": "MEER DETAILS WEERGEVEN",
  "groupSelection.titles.allianz_bundle_group_coach_2": "",
  "groupSelection.titles.allianz_bundle_group_guide_3": "",
  "groupSelection.titles.allianz_bundle_group_guide_4": "",
  "groupSelection.titles.barmenia_bundle_group_coach_2": "",
  "groupSelection.titles.barmenia_bundle_group_guide_2": "",
  "groupSelection.titles.barmenia_bundle_group_guide_3": "",
  "groupSelection.titles.bundle": "mySugr Bundel",
  "groupSelection.titles.coach": "mySugr Coach",
  "groupSelection.titles.gothaer_bundle_group_coach_2": "",
  "groupSelection.titles.gothaer_bundle_group_guide_3": "",
  "groupSelection.titles.pro": "mySugr PRO",
  "groupSelection.titles.roche_bundle_group_coach_1": "",
  "groupSelection.titles.roche_bundle_group_guide_1": "",
  "groupSelection.titles.ukv_bundle_group_coach_2": "",
  "groupSelection.titles.ukv_bundle_group_guide_3": "",
  "groupSelection.titles.vkb_bundle_group_coach_2": "",
  "groupSelection.titles.vkb_bundle_group_guide_3": "",
  "groupSelectionPage.priceFree": "Gratis",
  "groupSelectionPage.priceFreeExtra": "voor jou",
  "groupSelectionPage.title": "Kies een mySugr-programma",
  "header.heart.altText": "hart",
  "headerNotice.bundleNotAvailable": "Je kunt je niet meer inschrijven voor deze bundel. Hij is niet langer beschikbaar.",
  "headerNotice.bundleNotAvailable.barmer_1": "Je kunt je er niet meer voor inschrijven. De samenwerking met BARMER is beëindigd.",
  "headerNotice.infoNotice.linkText.us_bundle_3": "",
  "headerNotice.infoNotice.teaser.us_bundle_3": "",
  "headerNotice.infoNotice.text.us_bundle_3": "",
  "Help": "Help",
  "homepage.bundle.text": "Selecteer je land om de beschikbare <b>mySugr Bundels</b> te checken:",
  "homepage.bundle.text.us": "De mySugr Bundel is op dit moment alleen beschikbaar in de <b>Verenigde Staten</b>.",
  "homepage.bundle.title": "mySugr Bundel",
  "homepage.countries.defaultValue": "Selecteer een land",
  "homepage.pro.infoText": "De <b>DVG PRO-app</b> is alleen beschikbaar in Duitsland.",
  "homepage.pro.moreInfo": "Meer informatie",
  "homepage.pro.moreInfo.dvg": "Meer informatie",
  "homepage.pro.text": "Om je <strong>mySugr PRO app</strong>-tegoedbon in te wisselen:",
  "homepage.pro.title": "mySugr PRO App",
  "homepage.text": "Welkom in de mySugr Shop!",
  "insuranceCardForm.groupNumberLabel": "Verzekeringgroeps-ID",
  "insuranceCardForm.groupNumberLabel.edvoyles": "",
  "insuranceCardForm.groupNumberLabel.garfieldcounty": "",
  "insuranceCardForm.groupNumberLabel.mastec-1": "",
  "insuranceCardForm.groupNumberLabel.roche-benefits-us": "",
  "insuranceCardForm.groupNumberLabel.roche-benefits-us-coach": "",
  "insuranceCardForm.groupNumberPlaceholder": "000123",
  "insuranceCardForm.groupNumberPlaceholder.ActivisionBlizzard": "W1234567",
  "insuranceCardForm.groupNumberPlaceholder.buchanan-group-us": "000ABC123",
  "insuranceCardForm.groupNumberPlaceholder.edvoyles": "000ABC123",
  "insuranceCardForm.groupNumberPlaceholder.garfieldcounty": "",
  "insuranceCardForm.groupNumberPlaceholder.lazerspot": "000ABC123",
  "insuranceCardForm.groupNumberPlaceholder.mastec-1": "PHRASE01",
  "insuranceCardForm.infoTextGeneric": "Voer je verzekeringgroeps-ID en je lidmaatschaps-ID in zoals deze op je lidmaatschaps-ID-kaart staan.",
  "insuranceCardForm.infoTextGeneric.ActivisionBlizzard": "",
  "insuranceCardForm.infoTextGeneric.garfieldcounty": "",
  "insuranceCardForm.infoTextGeneric.kaiser.roche-benefits-us": "",
  "insuranceCardForm.infoTextGeneric.mastec-1": "",
  "insuranceCardForm.infoTextGeneric.roche-benefits-us-coach": "",
  "insuranceCardForm.memberIdLabel": "Lidmaatschaps-ID",
  "insuranceCardForm.memberIdLabel.ActivisionBlizzard": "",
  "insuranceCardForm.memberIdLabel.kaiser.roche-benefits-us": "",
  "insuranceCardForm.memberIdLabel.roche-benefits-us": "",
  "insuranceCardForm.memberIdLabel.roche-benefits-us-coach": "",
  "insuranceCardForm.memberIdPlaceholder": "123456789",
  "insuranceCardForm.memberIdPlaceholder.ActivisionBlizzard": "AZO 12345678X",
  "insuranceCardForm.memberIdPlaceholder.buchanan-group-us": "",
  "insuranceCardForm.memberIdPlaceholder.edvoyles": "",
  "insuranceCardForm.memberIdPlaceholder.garfieldcounty": "",
  "insuranceCardForm.memberIdPlaceholder.kaiser.roche-benefits-us": "",
  "insuranceCardForm.memberIdPlaceholder.lazerspot": "ABC12345678C",
  "insuranceCardForm.memberIdPlaceholder.mastec": "ABC0123456789",
  "insuranceNumberForm.label": "Verzekeringsnummer",
  "insuranceNumberForm.overlayButtonText": "Meer informatie",
  "introButtonLabelCreateAccount": "Account aanmaken",
  "languages.de": "Deutsch",
  "languages.en": "English",
  "languages.es": "Español",
  "languages.fr": "",
  "languages.nl": "Nederlands",
  "languageSelectLabel": "Taalinstellingen wijzigen",
  "login.pageName": "Login",
  "logoText.mySugr": "mySugr-programma",
  "logoText.payor": "in samenwerking met :payor",
  "measurementUnitSamples.mg/dl": "70 - 180",
  "measurementUnitSamples.mmol/l": "3,9 - 8,9",
  "more.info.overlay.linkText": "Meer informatie",
  "notFound.lead": "Wat je zoekt bestaat niet meer!",
  "notFound.text": "De pagina die je zoekt, bestaat niet of is verplaatst. Neem <a href=\"mailto::email\">contact met ons team</a> op voor hulp.",
  "notFound.title": "Pagina verdwenen",
  "notifications.CARD_DECLINED": "Je kaart is geweigerd.",
  "notifications.dismissNotification": "Melding negeren",
  "notifications.EXPIRED_CARD": "Je kaart is verlopen.",
  "notifications.IE11_NOT_SUPPORTED": "Je browser (Internet Explorer 11) wordt nu niet ondersteund. Je kunt op onze pagina problemen tegenkomen. Zou je een andere browser kunnen gebruiken?",
  "notifications.INCORRECT_CVC": "De CVC/CVV is niet correct.",
  "notifications.INCORRECT_NUMBER": "Creditcardnummer is niet correct.",
  "notifications.INSUFFICIENT_FUNDS": "Je kaart is geweigerd omdat deze onvoldoende saldo heeft.",
  "notifications.PROCESSING_ERROR": "We kunnen je kaart niet verwerken.",
  "notifications.SERVER_ERROR": "Fout bij contact maken met mySugr server",
  "notifications.STRIPE_ERROR": "Kan Stripe niet initialiseren",
  "notifications.TRIGGER_EMAIL_VERIFICATION_SUCCESS": "E-mail is zojuist verzonden",
  "notifications.UNDEFINED_ERROR": "Sorry, er is iets fout gegaan",
  "notifications.UNKNOWN_ERROR": "Er is iets fout gegaan.",
  "notifications.UNKNOWN_ERROR_2": "Oeps, er is iets fout gegaan",
  "notifications.USER_ALREADY_SUBSCRIBED_TO_BUNDLE": "Je bent al ingeschreven voor de mySugr Bundel.",
  "notifications.USER_ALREADY_SUBSCRIBED_TO_PLAN": "Je bent al ingeschreven voor de mySugr Bundel.",
  "numbers.0": "nul",
  "numbers.1": "een",
  "numbers.2": "twee",
  "numbers.3": "drie",
  "numbers.4": "vier",
  "numbers.5": "vijf",
  "numbers.6": "zes",
  "numbers.7": "zeven",
  "numbers.8": "acht",
  "numbers.9": "negen",
  "numbers.10": "tien",
  "offlinePage.subtitle": "Controleer je verbinding.",
  "offlinePage.title": "Oeps, je bent offline",
  "optionalConsent": "Optioneel:",
  "optionalPlaceholder": "Optioneel",
  "overlay.close": "Overlay sluiten",
  "overview.address.phone": "Telefoon:",
  "overview.autoCancelInfo.DAY.1": "De bundel eindigt automatisch na de eerste dag.",
  "overview.autoCancelInfo.DAY.2": "De bundel eindigt automatisch na :count dagen.",
  "overview.autoCancelInfo.MONTH.1": "De bundel eindigt automatisch na de eerste maand.",
  "overview.autoCancelInfo.MONTH.2": "De bundel eindigt automatisch na :count maanden.",
  "overview.autoCancelInfo.WEEK.2": "",
  "overview.autoCancelInfo.YEAR.1": "De bundel eindigt automatisch na het eerste jaar.",
  "overview.autoCancelInfo.YEAR.2": "De bundel eindigt automatisch na :count jaar.",
  "overview.backButton": "Terug",
  "overview.billingAddress.edit": "Bewerken",
  "overview.billingAddress.title": "Facturering",
  "overview.cancelationInfo.MONTH.1": "Je kunt de inschrijving op elk moment opzeggen na de eerste maand.",
  "overview.cancelationInfo.MONTH.2": "Je kunt de inschrijving op elk moment opzeggen na de eerste :count maanden.",
  "overview.cancelationInfo.YEAR.1": "Je kunt de inschrijving op elk moment opzeggen na het eerste jaar.",
  "overview.cancelationInfo.YEAR.2": "Je kunt de inschrijving op elk moment opzeggen na de eerste :count jaar.",
  "overview.coachLanguageOverview.change": "Wijzigen",
  "overview.coachLanguageOverview.title": "Coach-taal",
  "overview.contactDetails.edit": "Bewerken",
  "overview.contactDetails.title": "Contactgegevens",
  "overview.continueButton": "Bestellen",
  "overview.continueButton.at": "Bestellen",
  "overview.continueButton.at.fallback": "Bestellen",
  "overview.continueButton.ca.fallback": "",
  "overview.continueButton.de": "Bestellen",
  "overview.continueButton.de.fallback": "Bestellen",
  "overview.continueButton.es": "Bestellen",
  "overview.continueButton.es.fallback": "Bestellen",
  "overview.continueButton.nl.fallback": "Inschrijven",
  "overview.continueButton.sg.fallback": "Inschrijven",
  "overview.continueButton.us": "Inschrijven",
  "overview.continueButton.us.fallback": "Inschrijven",
  "overview.continueButton.us.optumrx_bundle_1": "Inschrijven",
  "overview.continueButton.us.us_bundle_3": "Inschrijven",
  "overview.continueButton.za.fallback": "Inschrijven",
  "overview.continueButton.za.south-africa_affiliate_(coaching_bundle)_2": "Inschrijven",
  "overview.enrollmentTitle": "Inschrijving in het programma",
  "overview.freeShipping": "Gratis verzending",
  "overview.measurementUnitOverview.change": "Wijzigen",
  "overview.measurementUnitOverview.mgdl": "mg/dL",
  "overview.measurementUnitOverview.mmoll": "mmol/L",
  "overview.measurementUnitOverview.title": "Meeteenheid",
  "overview.pageName": "Besteloverzicht",
  "overview.paymentOverview.change": "Bewerken",
  "overview.paymentOverview.creditCard": "Creditcard",
  "overview.paymentOverview.payment": "Betaling",
  "overview.payorCovered": "Dit programma wordt volledig gesponsord door je verzekering en is kosteloos voor je beschikbaar.",
  "overview.payorCovered.aok_nordwest_bundle_1": "",
  "overview.payorCovered.dec_i_bundle_1": "Dit programma wordt volledig gesponsord door het ziekenhuis en wordt zonder kosten beschikbaar gesteld.",
  "overview.payorCovered.dec_ii_bundle_1": "Dit programma wordt volledig gesponsord door het ziekenhuis en wordt zonder kosten beschikbaar gesteld.",
  "overview.payorCovered.onemed_bundle_1": "Dit programma wordt volledig gesponsord door je zorgverzekeraar en wordt zonder kosten beschikbaar gesteld.",
  "overview.payorCovered.optumrx_bundle_1": "",
  "overview.payorCovered.servidigest_bundle_1": "",
  "overview.payorCovered.us": "",
  "overview.payorCovered.us.activision_blizzard_bundle_1": "",
  "overview.payorCovered.us.bi_state_development_bundle_1": "Dit programma wordt volledig gesponsord door je werkgever en wordt zonder kosten beschikbaar gesteld.",
  "overview.payorCovered.us.buchanan_bundle_2": "",
  "overview.payorCovered.us.dhp_roche_ponce_bundle_1": "",
  "overview.payorCovered.us.garfield_county_bundle_1": "",
  "overview.payorCovered.us.genentech_bundle_1": "",
  "overview.payorCovered.us.lazer_spot_bundle_1": "",
  "overview.payorCovered.us.mastec_bundle_1": "",
  "overview.payorCovered.us.mysugr_ed_voyles_bundle_1": "",
  "overview.payorCovered.us.roche_bundle_us_1": "",
  "overview.payorCovered.us.roche_bundle_us_2": "",
  "overview.payorCovered.us.si_group_bundle_1": "",
  "overview.payorCovered.zdg_bundle_1": "",
  "overview.seller": "Verkoper",
  "overview.shipmentAddress.edit": "Bewerken",
  "overview.shipmentAddress.title": "Zending",
  "overview.shipmentOverview.edit": "Bewerken",
  "overview.shipmentOverview.title": "Verzendadres",
  "overview.stepName": "Overzicht",
  "overview.subscribeNotice": "Door op bovenstaande knop te klikken, geef je aan dat je ouder bent dan :minAge jaar.",
  "overview.title": "Je bent er bijna",
  "pageTitle": "mySugr Shop",
  "pageTitle.flowTitle.withPayor": "mySugr en :payorName",
  "pageTitle.flowTitle.withProductAndPayor": ":productName en :payorName",
  "pageTitle.withFlow": ":flowTitle",
  "pageTitle.withStep": ":stepTitle | mySugr Shop",
  "pageTitle.withStepAndFlow": ":stepTitle | :flowTitle",
  "passwordInput.hidePasswordButton": "Verbergen",
  "passwordInput.showPasswordButton": "Weergeven",
  "passwordReset.pageName": "Wachtwoord opnieuw instellen",
  "passwordResetSuccessPage.buttonText": "Doorgaan",
  "passwordResetSuccessPage.congratsImageAlt": "Gefeliciteerd, confetti vliegt in het rond,",
  "passwordResetSuccessPage.text": "Houd er rekening mee dat je wachtwoord ook is gewijzigd voor de mySugr app.",
  "passwordResetSuccessPage.title": "Je hebt je wachtwoord gewijzigd!",
  "payment.cardInfo.backButton": "Terug",
  "payment.cardInfo.changeCard": "Kaart wijzigen",
  "payment.cardInfo.continueButton": "Doorgaan",
  "payment.cardInfo.discardButton": "Terug naar het overzicht",
  "payment.cardInfo.expires": "Verloopt :month/:year",
  "payment.cardInfo.usingText": "Je betaalt met de creditcard <strong>:last4</strong>.",
  "payment.form.backButton": "Terug",
  "payment.form.cardNumberLabel": "Kaartnummer",
  "payment.form.continueButton": "Doorgaan",
  "payment.form.cvcLabel": "CVC/CVV",
  "payment.form.discardButton": "Wijzigingen ongedaan maken",
  "payment.form.expirationLabel": "Vervaldatum",
  "payment.form.firstNameLabel": "Voornaam",
  "payment.form.lastNameLabel": "Achternaam",
  "payment.form.nameLabel": "Naam op kaart",
  "payment.form.sameAsShipment": "Factuuradres is hetzelfde als leveringsadres",
  "payment.form.saveChangesButton": "Wijzigingen opslaan",
  "payment.stepName": "Betaling",
  "payment.title": "Betalingsinformatie",
  "paymentDetails.list.info": "Op deze kaart wordt je bundelabonnement periodiek in rekening gebracht.",
  "paymentDetails.list.title": "Betalingsinformatie",
  "paymentDetails.login.title": "Inloggen om je betalingsgegevens te wijzigen",
  "paymentLogos.title": "Ondersteunde betaalmethoden:",
  "product.bundleBoxImage.alt": "mySugr Bundel",
  "product.bundleBoxImage.alt.bundle_coach": "De mySugr Bundel: een doos met het mySugr-logo omgeven door de inhoud van de bundel en de mySugr App open op een telefoon met een chatballon boven de telefoon.",
  "product.bundleBoxImage.alt.bundle_guide": "De mySugr Bundel: een doos met het mySugr-logo omgeven door de inhoud van de bundel.",
  "product.bundleBoxImage.alt.bundle_guide_me": "De mySugr Bundel: een doos met het mySugr-logo omgeven door de inhoud van de bundel.",
  "product.bundleBoxImage.alt.coach": "Weergave van een telefoon met de mySugr App open en een chatballon naast de telefoon, gescheiden door een plusteken.",
  "product.bundleBoxImage.alt.pro": "Een telefoon met een ster met het woord ”Pro”",
  "product.continueButton": "",
  "product.items.moreInfo.dvg": "Meer informatie",
  "product.items.overlayText.dvg": "",
  "product.stepName": "Product",
  "product.submitButton": "",
  "product.title": "De mySugr Bundel",
  "productName.bundle": "mySugr Bundel",
  "productName.coach": "mySugr Coach",
  "promotion.APRILFOOLS2019_PROMOTION_PRICE_TEXT": "elke maand daarna",
  "promotion.APRILFOOLS2019_PROMOTION_TEXT": "1 maand gratis",
  "proVoucher.pageName": "PRO-tegoedbon inwisselen",
  "proVoucherInfo.checklist.challenges": "Neem deel aan <strong>uitdagingen</strong>",
  "proVoucherInfo.checklist.pdf": "<strong>PDF</strong>-rapporten",
  "proVoucherInfo.checklist.photos": "<strong>Maak foto's</strong> van je maaltijden",
  "proVoucherInfo.checklist.reminders": "Ontvang automatische <strong>herinneringen</strong>",
  "proVoucherInfo.checklist.search": "<strong>Zoeken</strong> - Vind je gegevens gemakkelijk",
  "proVoucherInfo.checklist.sync": "Synchroniseer <strong>meerdere apparaten</strong>",
  "proVoucherInfo.ctaButtonText": "Tegoedbon nu activeren",
  "proVoucherInfo.headline": "Je tegoedbon wordt geactiveerd ...",
  "proVoucherInfo.imageTitle": "mySugr PRO",
  "proVoucherInfo.stepName": "PRO-tegoedbon",
  "proVoucherInfo.validDate": "De functies worden ontgrendeld tot <strong>:date</strong>.",
  "proVoucherInfo.validTimeMonths": "De functies worden ontgrendeld voor <strong>:months maanden</strong>.",
  "proVoucherInfo.validTimeUnlimited": "Je krijgt <strong>onbeperkte</strong> toegang tot de functies.",
  "proVoucherInfo.voucherCodeValid": "De code van je tegoedbon <code>:voucherCode</code> is geldig.",
  "RDRegistration_description": "Ga mySugr gebruiken met je RocheDiabetes-account.",
  "RDRegistration_mySugr_description": "Wist je dat mySugr onderdeel is van RocheDiabetes. **Leer meer**",
  "RDSignIn_description": "Heb je al een account? Prima!",
  "readMoreBundleContentInformation": "Meer lezen over de inhoud van de bundel",
  "register.pageName": "Registratie",
  "reimbursement.overlay.text": "<h4>Hoeveel krijg ik vergoed?</h4> \n <p>Hetzelfde bedrag dat je krijgt wanneer je teststrips koopt in de apotheek. Afhankelijk van je verzekeringspolis is dat maximaal 100%.</p> \n\n <h4>Vergoeding is heel eenvoudig:</h4> \n <p>We sturen je de factuur per e-mail toe nadat je de bundel hebt gekocht. Je kunt de factuur afdrukken en ter vergoeding indienen bij je verzekering.</p>",
  "reimbursement.overlay.text.barmenia": "",
  "reimbursement.overlay.text.dkv": "",
  "reimbursement.overlay.text.gothaer": "",
  "reimbursement.overlay.text.ukv": "",
  "reimbursement.overlay.text.vkb": "",
  "reimbursement.overlay.title": "De mySugr Bundel",
  "reimbursement.overlay.title.allianz_bundle_group_coach_2": "",
  "reimbursement.overlay.title.barmenia_bundle_group_coach_2": "",
  "reimbursement.overlay.title.bundle": "De mySugr Bundel",
  "reimbursement.overlay.title.coach": "De bundel Diabetescoaching",
  "reimbursement.overlay.title.coach.dkv": "",
  "reimbursement.overlay.title.gothaer_bundle_group_coach_2": "",
  "reimbursement.overlay.title.ukv_bundle_group_coach_2": "",
  "reimbursement.overlay.title.vkb_bundle_group_coach_2": "",
  "selectCountry.selectCountryLabel": "Land selecteren",
  "selectPayor.otherInsuranceButton": "",
  "selectPayor.otherInsuranceExplanation": "",
  "selectPayor.pleaseSelect": "",
  "selectPayor.title": "",
  "shipment.contactDataForCoaches": "Alleen je persoonlijke coach krijgt je contactgegevens.",
  "shipment.form.address2Label": "Appartement, suite, enz.",
  "shipment.form.addressHint": "Geen postbus",
  "shipment.form.addressLabel": "Adres",
  "shipment.form.addressPlaceholder.germany": "Huisnummer/trap/deur",
  "shipment.form.backButton": "Terug",
  "shipment.form.billingAddressTitle": "Factuuradres",
  "shipment.form.birthdateCheckboxLabel": "Ik bevestig dat ik :minAge+ jaar oud ben en dat bij mij de diagnose diabetes is gesteld.",
  "shipment.form.birthdateHint": "Gebruiker moet :minAge+ jaar of ouder zijn.",
  "shipment.form.birthdateOverlayText": "<p>De mySugr Bundel is alleen beschikbaar voor mensen met diabetes van :minAge of ouder.</p><p>Je moet voldoen aan de volgende vereisten om je aan te melden voor de mySugr Bundel:</p><ol><li>De persoon die zich inschrijft voor de mySugr Bundel en deze gebruikt, moet gediagnosticeerd zijn met diabetes <strong>EN</strong> :minAge+ jaar of ouder zijn.</li><li>De persoon die zich inschrijft moet de gebruiker zijn. Het is niet toegestaan om voor een ander in te schrijven. (Ouders mogen hun kinderen niet inschrijven voor de mySugr Bundel).</li></ol><p>Elke overtreding van de bovenstaande vereisten zal leiden tot annulering van de inschrijving voor de mySugr Bundel. Voor meer informatie, zie onze <a href=\":tcsUrl\" target=\"_blank\" rel=\"noopener\">Bepalingen en voorwaarden voor gebruik</a>.</p>",
  "shipment.form.cityLabel": "Stad",
  "shipment.form.continueButton": "Doorgaan",
  "shipment.form.discardChangesButton": "Wijzigingen ongedaan maken",
  "shipment.form.emailLabel": "E-mailadres",
  "shipment.form.employerDefaultOption": "Selecteer een werkgever",
  "shipment.form.employerHint": "Via welke organisatie ontvang jij je gezondheidsvoordelen?",
  "shipment.form.employerLabel": "Werkgever",
  "shipment.form.firstNameLabel": "Voornaam",
  "shipment.form.lastNameLabel": "Achternaam",
  "shipment.form.memberClass.dependentLabel": "Afhankelijk",
  "shipment.form.memberClass.employeeLabel": "Zelf",
  "shipment.form.memberClass.explanation": "Relatie met verzekeringnemer",
  "shipment.form.phoneLabel": "Telefoonnummer",
  "shipment.form.policy.headline": "Verzekeringsinformatie",
  "shipment.form.postalCodeLabel": "Postcode",
  "shipment.form.postalCodeLabel_new": "Postcode",
  "shipment.form.saveChangesButton": "Wijzigingen opslaan",
  "shipment.form.stateDefaultOption": "Selecteer een staat",
  "shipment.form.stateLabel": "Staat",
  "shipment.form.zipCodeLabel": "Postcode",
  "shipment.stepName": "Zending",
  "shipment.title": "<strong>Verzend</strong>informatie",
  "shoppingCart.deliverOnce": "(eenmaal leveren)",
  "shoppingCart.immediateTitle": "Onmiddellijke toegang tot:",
  "shoppingCart.productTitle": "Jouw doos arriveert binnen enkele dagen:",
  "shoppingCart.subscriptionTitle": "Continue toegang tot:",
  "shoppingCart.title": "Je bundel omvat:",
  "shoppingCart.title.dvg": "",
  "shoppingCart.title.roche-benefits-us": "",
  "shoppingCart.title.roche-benefits-us-coach": "",
  "SignIn": "Aanmelden",
  "SignInMySugr": "Aanmelden met mySugr-ID",
  "stepBar.activeStep.screenReader": "(actieve stap)",
  "stepBar.completedStep.screenReader": "(voltooide stap)",
  "stepBar.notCompletedStep.screenReader": "(niet voltooide stap)",
  "stepBar.remaining": "Je bent nog maar <strong>:remaining stappen</strong> verwijderd van je bundel!",
  "stepBar.title.screenReader": "Vereiste stappen om je in te schrijven voor de mySugr Bundel",
  "stepIndicationText": "Stap :current van :total",
  "success.coach.text": "Er ligt zelfs een bericht van je coach voor je klaar in de app.",
  "success.coach.title": "Zeg <b>”Hallo”</b> tegen je <b>persoonlijke coach</b>",
  "success.doneButton": "Klaar",
  "success.download.bundle.text": "<b>Volg</b> je <b>dagelijkse metingen</b> en wij houden bij hoeveel strips je hebt gebruikt.",
  "success.download.coach.text": "<b>Volg</b> je <b>dagelijkse metingen</b>, zodat je op de hoogte blijft van je diabetes.",
  "success.download.title": "Vervolgens <b>download</b> je de mySugr <b>App</b>",
  "success.help": "Als er iets onduidelijk is, neem dan gerust contact op met ons geweldige ondersteuningsteam.",
  "success.nextStep1": "<strong>Download</strong> de mySugr <strong>app</strong>",
  "success.nextStep2": "<strong>Log in</strong> met je e-mail <strong>:email</strong> en <strong>wachtwoord</strong>",
  "success.nextStep3": "<strong>Helemaal klaar!</strong>",
  "success.orderSuccess.coachText": "Volg de volgende stappen om contact op te nemen met je coach.",
  "success.orderSuccess.deliveryText": "We sturen je een e-mail met de details van je eerste levering. \n\n<b>Alle toekomstige leveringen zullen worden geactiveerd vanuit de app.</b>",
  "success.orderSuccess.title": "Je bestelling is <b>gelukt</b>",
  "success.pageFooterTitle": "Volg deze eenvoudige stappen en blijf op de hoogte!",
  "success.pageName": "Bestelling succesvol",
  "success.payment.change": "Kaart is bijgewerkt!",
  "success.proVoucherInfo.validDate": "De functies worden ontgrendeld tot <strong>:date</strong>.",
  "success.proVoucherInfo.validTimeMonths": "Je PRO-functies zijn nu ontgrendeld gedurende <strong>:months maanden</strong>.",
  "success.proVoucherInfo.validTimeUnlimited": "Je hebt nu <strong>onbeperkt</strong> toegang tot alle PRO-functies.",
  "success.proVoucherInfo.validTimeUnlimited.dvg": "Je hebt nu toegang tot alle PRO-functies.",
  "success.shippingInfo": "Je bundel zal binnen <strong>5-7 werkdagen</strong> arriveren.",
  "success.shippingInfoDynamic": "Je bundel zal binnen <strong>:time werkdagen</strong> arriveren.",
  "success.shippingMoreInfo": "Wanneer je de bundel hebt ontvangen, maak je verbinding met de meter en ga je zoveel mogelijk gegevens invoeren. Zorg altijd voor <b>synchronisatie met de app</b> – alleen zo kunnen wij beoordelen of het tijd is om <b>extra teststrips</b> naar u toe te sturen.",
  "success.stepName": "Voltooid",
  "success.title": "Je bestelling is <strong>succesvol voltooid!</strong>",
  "success.titleProOnly": "Gefeliciteerd,<br> je bent nu een <strong>PRO-gebruiker</strong>!",
  "success.trackingInfo": "We sturen je binnen twee dagen een e-mail met een tracking-ID zodat je de levering op de voet kunt volgen!",
  "unitSelection.buttonText": "Selecteren",
  "unitSelection.label": "Selectie van eenheid",
  "unitSelection.labelClose": "Selectie van eenheid sluiten",
  "unitSelection.title": "Selecteer je <strong>meeteenheid</strong>",
  "voucher.pageName": "Tegoedbon inwisselen",
  "voucherForm.buttonText": "Controleer tegoedbon",
  "voucherForm.label": "Code van tegoedbon",
  "voucherForm.overlayButtonText": "Meer informatie",
  "voucherForm.overlayText": "Je kunt de 12-cijferige code van de tegoedbon vinden in de brief die je ontvangt van je verzekering. Als je nog geen code hebt ontvangen, neem contact op het met je verzekering.",
  "voucherForm.overlayText.aok_1": "",
  "voucherForm.overlayText.aok_nordwest_1": "",
  "voucherForm.overlayText.barmer_1": "",
  "voucherForm.overlayText.bi_state_development_1": "Voer de 12-cijferige code van de tegoedbon in die je hebt ontvangen om toegang te krijgen tot dit aanbod.",
  "voucherForm.overlayText.dkv": "",
  "voucherForm.overlayText.fayette_county_1": "",
  "voucherForm.overlayText.genentech_1": "",
  "voucherForm.overlayText.jbz_1": "Je kunt de 12-cijferige code van de tegoedbon vinden in de brief die je ontvangt van het ziekenhuis. Als je nog geen code hebt ontvangen, neem contact op het met het ziekenhuis.",
  "voucherForm.overlayText.mmc_1": "Je kunt de 12-cijferige code van de tegoedbon vinden in de brief die je ontvangt van het ziekenhuis. Als je nog geen code hebt ontvangen, neem contact op het met het ziekenhuis.",
  "voucherForm.overlayText.onemed_1": "Je kunt de 12-cijferige code van de tegoedbon vinden in de brief/e-mail die je ontvangt van OneMed. Als je nog geen code hebt ontvangen, neem dan contact op het met OneMed.",
  "voucherForm.overlayText.roche_pl_1": "--- MISSING ---",
  "voucherForm.overlayText.roche_sg_1": "",
  "voucherForm.overlayText.schwenninger_1": "",
  "voucherForm.overlayText.servidigest_1": "",
  "voucherForm.overlayText.si_group_1": "",
  "voucherForm.overlayText.zdg_1": "",
  "voucherForm.title": "Wissel je tegoedbon in!"
};